<template>
    <div class="">
        <table>
            <thead>
                <tr>
                    <th class="th-name">Name</th>
                    <th class="th-email">E-mail</th>
                    <th class="th-role">Role</th>
                    <th class="th-date">Reg. Date</th>
                    <th class="th-status">Status</th>
                    <th class="th-buttons"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="listEmpty" class="empty">
                    <td colspan="6">Not found</td>
                </tr>

                <tr v-for="user in users" :key="user.id" :class="{'admin' : user.role === 'admin'}">
                    <td :title="user.userName">
                        <router-link :to="userPageUrl(user.userName, user.id)" :title="user.userName">{{ user.userName }}</router-link>
                    </td>
                    <td :title="user.email">
                        {{ user.email }}
                    </td>
                    <td class="no-wrap td-role">
                        {{ user.role }}
                    </td>
                    <td class="no-wrap">
                        {{ dateFormat(user.date_created) }}
                    </td>
                    <td class="no-wrap" :class="[user.active ? 'color-green' : 'color-red']">
                        {{ userStatus(user.active) }}
                    </td>
                    <td class="no-wrap">
                        <button class="btn" title="Edit" @click="openEditUserModal(user.id)"><i class="icon-pencil"></i></button>
                        <button class="btn btn-delete" title="Delete" @click="openDeleteUserModal(user)"><i class="icon-trash-empty"></i></button>
                    </td>
                </tr>
            </tbody>
        </table>

        <EditUserModal v-if="displayEditUserModal"
                       :user="userToEdit"
                       @closeModal="closeEditUserModal"
        ></EditUserModal>

        <DeleteUserModal v-if="displayDeleteUserModal"
                         :user="userToDelete"
                         @closeModal="closeDeleteUserModal"
        ></DeleteUserModal>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import EditUserModal from "./EditUserModal";
    import DeleteUserModal from "./DeleteUserModal";

    export default {
        name: "UsersTable",

        components: {
            DeleteUserModal,
            EditUserModal,
        },

        props: [
            'users',
        ],

        data() {
            return {
                userToEdit: null,
                userToDelete: null,
                displayEditUserModal: false,
                displayDeleteUserModal: false,
            }
        },

        computed: {
            ...mapGetters('users', [
                'userPageUrl',
            ]),

            listEmpty() {
                return !this.users.length;
            },

        },

        methods: {
            ...mapActions('users', [
                'getUser',
            ]),

            dateFormat(date) {
                return date?.slice(0,10);
            },

            userStatus(active) {
                return active ? 'active' : 'banned';
            },

            async openEditUserModal(userId) {
                this.userToEdit = await this.getUser(userId);

                this.displayEditUserModal = true;
            },

            closeEditUserModal() {
                // clear variable
                this.userToEdit = null;

                this.displayEditUserModal = false;
            },

            openDeleteUserModal(user) {
                this.userToDelete = user;

                this.displayDeleteUserModal = true;
            },

            closeDeleteUserModal() {
                // clear variable
                this.userToDelete = null;

                this.displayDeleteUserModal = false;
            },

        },

    }
</script>

<style scoped>
    .th-role,
    .th-status {
        width: 80px;
        min-width: 80px;
        max-width: 80px;
    }

    .th-date {
        width: 120px;
        min-width: 120px;
        max-width: 120px;
    }

    .th-buttons {
        width: 75px;
        min-width: 75px;
        max-width: 75px;
    }

    .admin {
        font-weight: 700;
        background: #c7dcf3;
    }

    .admin:hover {
        background: #d7e6f6;
    }

    .btn {
        padding: 0 2px;
        border: none;
        font-size: 16px;
        line-height: 1;
        text-align: center;
        color: #aaa;
        background: none;
        cursor: pointer;
    }

    .btn:hover {
        color: #000;
    }

    .btn-delete:hover {
        color: #ad0100;
    }

</style>